import { useContext, useEffect, useState } from "react";
import { ResidentDto } from "../../dtos/ResidentDto";
import { VillageDto } from '../../dtos/VillageDto';
import { Box, Stack } from '@mui/material';
import { ManageCommonAreaAccess } from './ManageCommonAreaAccess';
import { SearchBhpEmployeeContractor } from '../VillageWifi/SearchBhpEmployeeContractor';
import { Asset } from "../../data/Asset";
import { CheckHealth } from "../Maintenance/components/CheckHealth";
import { SelectMultipleVillages } from "../../components/SelectMultipleVillages";
import VspPortalContext from "../../store/VspPortalContext";


export const CommonAreaAccess: React.FC = () => {
   
    // const [ defaultVillages, setDefaultVillages  ] = useState< string[ ]> ([ ]);
    const [ resident, setResident ] = useState<ResidentDto>( );
    const [ villages, setVillages ] = useState< VillageDto[ ] >( [ ] );

    const { state } = useContext( VspPortalContext );

    // useEffect(()=>{

    //     // select all villages
    //     if( !state.villages[ Asset.Waio ] ) return;
    //     setDefaultVillages( state.villages[ Asset.Waio ].map( v => v.villageCode ) );
    //     setVillages( state.villages[ Asset.Waio ] );

    // },[ state.villages ]);

    
    const handleSelectResident = ( resident : ResidentDto | undefined ) => setResident( resident );

    const handleSelectVillages = ( villageCodes : string[ ] ) => setVillages( state.villages[ Asset.Waio ].filter( v => villageCodes.includes( v.villageCode )) );
        


    return (
 
        <>

            <CheckHealth />

            <Stack justifyContent="center" spacing={ 1 } sx={{ alignItems :"center", marginTop: '10px' }}>

                <SearchBhpEmployeeContractor assets={[ /*Asset.Niw,*/ Asset.Waio ]} onSelectResident={ handleSelectResident } />
                
                {
                    resident 
                        &&
                    <>
                        <Box sx={{ height: '10px' }} />
                        <SelectMultipleVillages defaultVillages={ /*defaultVillages*/[ ] } selectVillages={ handleSelectVillages }/>
                        { villages.map( village => <ManageCommonAreaAccess key={ village.villageCode } resident={ resident } village={ village }/> ) }
                    </>

                }
                
            </Stack>

        </>

    );
  
};